var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { handleIsOpen } from '../../store/slices/healthMonitorsSlice';
import { useAppDispatch, useAppSelector } from '../../store';
import { createSelector } from '@reduxjs/toolkit';
import MonitorAlert from './Alert';
import { getDefaultsMonitor } from '../../mock/health';
import Chart from '../charts/Index';
const healthMonitorPanel = () => {
    _react_refresh_temp_1();
    const dispatch = useAppDispatch();
    const closeHelathMonitorPanel = () => {
        dispatch(handleIsOpen(false));
    };
    const isActiveMonitorPanelSelector = createSelector((state) => state.healthMonitor, (healthMonitor) => healthMonitor.isOpen);
    const isActiveHealthMonitorPanel = useAppSelector(isActiveMonitorPanelSelector);
    const [allowHealthMonitor, setAllowHealthMonitor] = useState(isActiveHealthMonitorPanel);
    const monitors = getDefaultsMonitor();
    useEffect(() => {
        setAllowHealthMonitor(isActiveHealthMonitorPanel);
    }, [isActiveHealthMonitorPanel]);
    const cssClass = allowHealthMonitor ? 'monitor-panel open' : 'monitor-panel close';
    return ((_jsx("div", { id: "main-health-monitor-panel", className: cssClass, children: _jsxs("div", { className: 'wrapper-health-monitor', children: [_jsxs("div", { className: 'monitor-header', children: [_jsx("div", { className: 'monitor-patient name', children: "Nome paziente" }), _jsx("div", { className: 'monitor-patient close-modal', children: _jsx("button", { onClick: () => closeHelathMonitorPanel(), children: _jsx("img", { src: '../../assets/imgs/close-icon.svg', alt: 'close-icon' }) }) })] }), _jsx("div", { className: 'monitor-content', children: monitors.map((monitor, index) => {
                        return _jsx(MonitorAlert, { type: monitor }, index);
                    }) }), _jsx("div", { className: 'monitor-chart', children: monitors.map((monitor, index) => {
                        return _jsx(Chart, { type: 'Line', title: monitor }, index);
                    }) })] }) })));
};
_react_refresh_temp_1(healthMonitorPanel, "Ba5EBQ8uUnokE6UwmSHFxqypSdk=", false, () => [useAppDispatch, useAppSelector]);
export default React.memo(healthMonitorPanel);
